import React, { useEffect, useState } from "react";
import axios from "../../api/axios";
import { useAuth } from "../../context/AuthProvider"; // ✅ Import this

import "./styles/AdminMessages.css"; // ✅ Reuse same styles for now

const AdminUsers = () => {
  const { auth } = useAuth();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchUsers = async () => {
    try {
      const response = await axios.get("/api/admin/users");
      setUsers(response.data.users);
    } catch (error) {
      console.error("🔥 Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const getCsrfToken = () => {
    return document.cookie
      .split("; ")
      .find(row => row.startsWith("csrfToken="))
      ?.split("=")[1];
  };
  
  const handleDelete = async (userId) => {
    if (!window.confirm("❗ Are you sure you want to delete this user?")) return;
    try {
      const csrfToken = getCsrfToken();
      await axios.delete(`/api/admin/users/${userId}`, {
        withCredentials: true,
        headers: { "x-csrf-token": csrfToken }
      });
      setUsers(users.filter((user) => user.id !== userId));
    } catch (error) {
      console.error("🔥 Error deleting user:", error);
    }
  };
  
  const handleRoleChange = async (userId, newRole) => {
    try {
      const csrfToken = getCsrfToken();
      await axios.put(
        `/api/admin/users/${userId}`,
        { role: newRole },
        {
          withCredentials: true,
          headers: { "x-csrf-token": csrfToken }
        }
      );
      fetchUsers(); // Refresh users after update
    } catch (error) {
      console.error("🔥 Error updating role:", error);
    }
  };
  
  const [showEmailField, setShowEmailField] = useState(false);
const [adminPassword, setAdminPassword] = useState("");
const [inviteEmail, setInviteEmail] = useState("");
const [inviteStatus, setInviteStatus] = useState("");
const [sendingInvite, setSendingInvite] = useState(false);
const [showPasswordField, setShowPasswordField] = useState(false);


const handlePasswordSubmit = (e) => {
  e.preventDefault();
  setShowEmailField(true);
};

const handleSendInvite = async (e) => {
  e.preventDefault();
  setInviteStatus("");
  setSendingInvite(true);
  try {
    const csrfToken = getCsrfToken();
    await axios.post(
      "/api/admin/send-invite",
      { email: inviteEmail, adminPassword },
      {
        withCredentials: true,
        headers: { "x-csrf-token": csrfToken }
      }
    );
    setInviteStatus("Invitation sent!");
    setInviteEmail("");
    setAdminPassword(""); // Optional: reset password after each send
    setShowEmailField(false);
  } catch (err) {
    setInviteStatus(
      err.response?.data?.error || "Failed to send invitation."
    );
  }
  setSendingInvite(false);
};


  return (
    <div className="admin-messages-container">
      <h2 className="messages-title">Registered Users</h2>
  
      {loading ? (
        <p className="messages-loading">Loading users...</p>
      ) : users.length === 0 ? (
        <p className="messages-empty">No users found.</p>
      ) : (
        <div className="table-wrapper">
          <div style={{marginBottom: 32}}>
  <h3>Send Registration Invite</h3>
  {/* Step 1: Show only button if neither field is showing */}
  {!showPasswordField && !showEmailField && (
    <button
      onClick={() => setShowPasswordField(true)}
      className="btn invite-btn"
      style={{marginBottom: 8}}
    >
      <i className="fa-solid fa-user-plus"></i> Invite User
    </button>
  )}

  {/* Step 2: Show password field if showPasswordField=true and showEmailField=false */}
  {showPasswordField && !showEmailField && (
    <form onSubmit={(e) => {
      e.preventDefault();
      setShowEmailField(true);
    }} style={{marginBottom: 8}}>
      <input
        type="password"
        placeholder="Enter your admin password"
        value={adminPassword}
        onChange={(e) => setAdminPassword(e.target.value)}
        required
        disabled={sendingInvite}
      />
      <button type="submit" disabled={!adminPassword || sendingInvite}>
        Next
      </button>
      <button
        type="button"
        style={{marginLeft: 12}}
        onClick={() => {
          setShowPasswordField(false);
          setAdminPassword("");
        }}
        disabled={sendingInvite}
      >
        Cancel
      </button>
    </form>
  )}

  {/* Step 3: Show email field if showEmailField=true */}
  {showEmailField && (
    <form onSubmit={handleSendInvite}>
      <input
        type="email"
        placeholder="Email to invite"
        value={inviteEmail}
        onChange={(e) => setInviteEmail(e.target.value)}
        required
        disabled={sendingInvite}
      />
      <button type="submit" disabled={!inviteEmail || sendingInvite}>
        {sendingInvite ? "Sending..." : "Send Invite"}
      </button>
      <button
        type="button"
        style={{marginLeft: 12}}
        onClick={() => {
          setShowEmailField(false);
          setShowPasswordField(false);
          setAdminPassword("");
          setInviteEmail("");
        }}
        disabled={sendingInvite}
      >
        Cancel
      </button>
    </form>
  )}

  {inviteStatus && (
    <p
      style={{
        color: inviteStatus.includes("sent") ? "green" : "red",
        marginTop: 4,
      }}
    >
      {inviteStatus}
    </p>
  )}
</div>


          <table className="messages-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Email</th>
                <th>Role</th>
                <th>Created At</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.id}>
                  <td>{user.id}</td>
                  <td>{user.name}</td>
                  <td>{user.email}</td>
                  <td>
                    {auth.user?.id === user.id ? (
                      user.role
                    ) : (
                      <select
                        value={user.role}
                        onChange={(e) => handleRoleChange(user.id, e.target.value)}
                        className="role-select"
                      >
                        <option value="user">User</option>
                        <option value="admin">Admin</option>
                      </select>
                    )}
                  </td>
                  <td>{new Date(user.created_at).toLocaleString()}</td>
                  <td className="table-actions">
                    {auth.user?.id !== user.id && (
                      <button className="btn delete-btn" onClick={() => handleDelete(user.id)}>
                        <i className="fa-solid fa-xmark"></i> Delete
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
  
};

export default AdminUsers;